import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuillModule } from 'ngx-quill';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { ListContactsComponent } from './components/list-contacts/list-contacts.component';
import { AddContactsComponent } from './modals/add-contacts/add-contacts.component';
import { EditContactsComponent } from './modals/edit-contacts/edit-contacts.component';

const MODULES = [
  MatIconModule,
  MatFormFieldModule,
  MatTableModule,
  MatPaginatorModule,
  MatDialogModule,
  FormsModule,
  ReactiveFormsModule,
  MatSelectModule,
  MatInputModule,
  FlexLayoutModule,
  MatButtonModule,
  MatCardModule,
  MatMenuModule,
  MatSortModule,
  MatListModule,
  DragDropModule,
  MatSlideToggleModule,
  MatTooltipModule,
  QuillModule,
  MatStepperModule,
  MatExpansionModule,
  MatDatepickerModule,
  MatNativeDateModule,
  SelectDropDownModule,
  MatCheckboxModule,
  MatProgressBarModule
]

@NgModule({
  declarations: [ListContactsComponent, AddContactsComponent, EditContactsComponent],
  imports: [
    CommonModule,
    ...MODULES
  ],
  exports: [ListContactsComponent]
})
export class ContactsModule { }
